import { render, staticRenderFns } from "./ParametreReservation.vue?vue&type=template&id=67f77e58"
import script from "./ParametreReservation.vue?vue&type=script&lang=js"
export * from "./ParametreReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports